import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { TransmissionTypes } from "@/types";

export interface TransmissionTestState {
  result: TransmissionTypes.TestClaimRawResponseData;
}

const DEFAULT_TRANSMISSION_TEST_STATE: TransmissionTestState = {
  result: {
    transaction_response_status: "",
  },
};

export default (state: TransmissionTestState = DEFAULT_TRANSMISSION_TEST_STATE, action: Action): {} => {
  if (action.type === ActionTypes.TRANSMISSION_TEST_RESULT) {
    return {
      result: action.payload,
    };
  } else {
    return state;
  }
};
